import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'excludeByList'
})
export class ExcludeByListPipe implements PipeTransform {

  /**
   * Exclude an array with an other array
   * @param {any[]} array
   * @param {any[]} exclude
   * @param update
   * @returns {any[]}
   */
  // noinspection JSUnusedLocalSymbols
  transform(array: any[], exclude: any[], update: any): any[] {
    return array.filter((item) => {
      return exclude.filter((i) => i.id === item.id).length === 0;
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/pipes/exclude-by-list.pipe.ts